import React from "react";
import "./News.css";

function News() {
  const news = [
    {
      category: "CAREERS",
      date: "Graduate Programme",
      title: "Graduate Trainee Program",
      description:
        "Our Graduate Trainee Program develops emerging professionals through practical experience, mentorship and exposure to energy and maritime operations.",
      image: "/images/Young Professionals.png",
      imageAlt: "Young professionals at an industrial worksite",
      imagePosition: "center 22%",
    },

    {
      category: "SECURITY",
      date: "Cybersecurity Program",
      title: "Cybersecurity Program",
      description:
        "Strengthening digital resilience through cybersecurity practices that help protect our people, systems, data and operations.",
      image: "/images/cybersecurity.webp",
    },

    {
      category: "PEOPLE",
      date: "August Recognition",
      title: "Employee of the Month: August",
      description:
        "Celebrating Ediworo as our Employee of the Month for August and recognizing their commitment, excellence and contribution to the Strides team.",
      image: "/images/ediworo.webp",
    },
  ];

  return (
    <section className="news" id="news">

      <div className="news-container">

        {/* ==================================================
            HEADER
            ================================================== */}

        <div className="news-header">

          <div>

            <span className="news-eyebrow">
              NEWS & INSIGHTS
            </span>

            <h2>
              What’s Happening
              <br />
              at Strides.
            </h2>

          </div>

          <a
            href="#news"
            className="news-header-button"
          >
            <span>View All News</span>
            <span>→</span>
          </a>

        </div>


        {/* ==================================================
            NEWS GRID
            ================================================== */}

        <div className="news-grid">

          {news.map((item) => (

            <article
              className="news-card"
              key={item.title}
            >

              {/* IMAGE */}

              <div className="news-image-wrapper">

                <img
                  src={item.image}
                  alt={item.imageAlt || item.title}
                  className="news-image"
                  style={item.imagePosition ? { objectPosition: item.imagePosition } : undefined}
                />

                <div className="news-image-overlay"></div>

              </div>


              {/* CONTENT */}

              <div className="news-content">

                <div className="news-meta">

                  <span>
                    {item.category}
                  </span>

                  <span>
                    {item.date}
                  </span>

                </div>

                <h3>
                  {item.title}
                </h3>

                <p>
                  {item.description}
                </p>

              </div>

            </article>

          ))}

        </div>

      </div>

    </section>
  );
}

export default News;